export const MESSAGES = {
  captchInvalid: "Captcha is invalid",
  signUpSuccess:
    "Your signup request is submitted to admin for review. We will update you once it is confirmed.",
  passwordReset: "Password Reset Successful",
  noRecordFound: "No record found",
  somethingWentWrong : "Something went wrong please try again.",
  requiredDateTime: "Date & Time field is required.",
  passwordChanged: "Password Changed Successfully",
  signatureUploaded: "Signature Uploaded Successfully",
  passwordCreatedSuccess: "Password Created Successfully.",

  login: "Login Successfully.",
  not_authorize: "You are not authorized with your system.",
  resetPassword_error: "Password reset fail.",
  user_not_found: "No users found with this email.",
  user_not_active:
    "Your account is not Activated. Please contact with administration team for more detail",
  create_password_error:
    "Something went wrong in create password, please try again.",
  create_user_password: "Password Created Successfully, please login now.",
  user_already_exist:
    "Email Already Exist in our system please try with different email.",
  new_user: "New User.",
  token_expired: "Your token is expired, please try complete process again.",
  reset_password_success: "Password reset successfully .",
  forgot_password_success: "Email sent to your registered email address.",
  user_not_authorized:
    "You are not authorized to login. Please contact with administration team for more detail",
  confirmButtonColor: "#FDB711",
  cancelButtonColor: "#dedede",
  color: "#000000",
  title: "Are you sure?",
  text: "You won't be able to revert this!",
  icon: "warning",
  deleteIt: "Yes, delete it!",
  machineInspecctionDone: "Machine Inspection has been done.",
  noDocumentFound : "No documents found for this SR."
};

export const VALIDATION = {
  tollsCost: "Tolls must be a number.",
  mealsCost: "Meals must be a number.",
  lodgingCost: "Lodging must be a number.",
  mileageCost: "Mileage must be a number.",
  miscCost: "Misc. must be a number.",
  inspectionStart:
    "Inspection start time must be greater than travel start time",
  inspectionStop:
    "Inspection stop time must be greater than inspection start time",
  travelStop: "Travel stop time must be greater than inspection stop time",
  noRecords: "There are no records to display",
  onlyImagesAllowed: "Only image files are allowed.",
  fileIsRequired: "A file is required",
  imageSizeExceeded:
    "Image size exceeded than 10MB. Every image should be less than 10MB.",
  poNumberAlphanumeric: "PO number should be alphanumeric and dash",
  maxCapacityAlphanumeric: "Max Capacity should be alphanumeric",
  userEmailsRequire : "At least one email is required",
  maximumEmailError : "Only 30 emails are allowed at a time "
};
